/** Project API — Faz 1.4 createApi factory. Önce: 202 satır / 23 metot. Sonra. */
import {createApi} from './_factory'
import type {CommonNs, ProjectNs} from '@shared/types'

const project = createApi('project')
const trash = createApi('trash')

export const ProjectApi = {
  // — Tek proje —
  getProject: (projectId: string) =>
    project.get<ProjectNs.Project>(projectId),
  getProjectDetail: (projectId: string) =>
    project.get<ProjectNs.ProjectDetail>(`${projectId}/detail`),
  getProjectContents: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, ProjectNs.ProjectContents>('contents', data),

  // — Liste / library —
  getAllProjectsInWorkspace: (data: ProjectNs.GetProjectsInWorkspaceRequest) =>
    project.post<ProjectNs.GetProjectsInWorkspaceRequest, ProjectNs.Project[]>('get-all-projects-in-workspace', data),
  getUserProjectsInWorkspace: (data: ProjectNs.GetUserProjectsInWorkspaceRequest) =>
    project.post<ProjectNs.GetUserProjectsInWorkspaceRequest, ProjectNs.Project[]>('get-user-projects-in-workspace', data),
  getLibraryProjectsInWorkspace: (data: ProjectNs.GetProjectsInWorkspaceRequest) =>
    project.post<ProjectNs.GetProjectsInWorkspaceRequest, ProjectNs.Project[]>('list/libraries', data),

  // — CRUD —
  addProject: (data: ProjectNs.AddProjectRequest) =>
    project.post<ProjectNs.AddProjectRequest, ProjectNs.AddProjectResponse>('add-project', data),
  updateProject: (data: ProjectNs.UpdateProjectRequest) =>
    project.post<ProjectNs.UpdateProjectRequest, ProjectNs.Project>('update-project', data),
  updateProjectDetail: (data: ProjectNs.UpdateProjectDetailRequest) =>
    project.post<ProjectNs.UpdateProjectDetailRequest, ProjectNs.ProjectDetail>('update-project-detail', data),
  moveProject: (data: ProjectNs.MoveProjectRequest) =>
    project.post<ProjectNs.MoveProjectRequest, CommonNs.GenericResponse>('move-to-container', data),
  deleteProject: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, CommonNs.GenericResponse>('remove-project', data),

  // — Trash —
  deletePermanentlyProject: (data: ProjectNs.GenericProjectRequest) =>
    trash.post<ProjectNs.GenericProjectRequest, ProjectNs.Project[]>('delete-permanently', data),
  restoreProject: (data: ProjectNs.GenericProjectRequest) =>
    trash.post<ProjectNs.GenericProjectRequest, ProjectNs.Project[]>('restore-project', data),
  getProjectsFromTrash: (data: ProjectNs.GetProjectFromTrashRequest) =>
    trash.post<ProjectNs.GetProjectFromTrashRequest, ProjectNs.Project[]>('get-projects', data),
  getTrashedProjectCount: (data: ProjectNs.GetProjectFromTrashRequest) =>
    trash.post<ProjectNs.GetProjectFromTrashRequest, number>('get-project-count', data),

  // — Member —
  getProjectMemberList: (data: ProjectNs.GetProjectMembersRequest) =>
    project.post<ProjectNs.GetProjectMembersRequest, ProjectNs.Member[]>('get-project-members', data),
  addMemberToProject: (data: ProjectNs.ChangeProjectMemberStatusRequest) =>
    project.post<ProjectNs.ChangeProjectMemberStatusRequest, ProjectNs.Member>('add-member-to-project', data),
  deleteMemberFromProject: (data: ProjectNs.ChangeProjectMemberStatusRequest) =>
    project.post<ProjectNs.ChangeProjectMemberStatusRequest, CommonNs.AnyResponse>('delete-member-from-project', data),
  changeProjectMemberRole: (data: ProjectNs.ChangeProjectMemberStatusRequest) =>
    project.post<ProjectNs.ChangeProjectMemberStatusRequest, CommonNs.AnyResponse>('change-project-member-role', data),

  // — Publish —
  publishProject: (data: ProjectNs.PublishProjectRequest) =>
    project.post<ProjectNs.PublishProjectRequest, ProjectNs.PublishProjectResponse>('do-publish', data),
  unpublishProject: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, CommonNs.AnyResponse>('unpublish', data),
  loadPublishedProject: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, ProjectNs.PublishProjectResponse>('get-publish-info', data),
  makeProjectSearchable: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, CommonNs.AnyResponse>('make-searchable', data),
  makeProjectUnsearchable: (data: ProjectNs.GenericProjectRequest) =>
    project.post<ProjectNs.GenericProjectRequest, CommonNs.AnyResponse>('make-unsearchable', data),
}
